<template>
    <modal-wrapper modalClass="modal modal__large" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h1>{{file.name}}</h1>
        </div>
        <div class="spinner" v-if="loading"></div>
        <div v-else>
            <video v-if="video" controls controlsList="nodownload" disablePictureInPicture>
                <source :src="url">
                {{$t('dashboard.files.could_not_open')}}
            </video>
            <audio v-else-if="audio" controls controlsList="nodownload">
                <source :src="url">
                {{$t('dashboard.files.could_not_open')}}
            </audio>
            <div v-else-if="image">
                <img :src="url" alt="" />
            </div>
            <object v-else-if="pdf" type="application/pdf" :data="url + '#toolbar=0'" width="100%" height="500px"></object>
            <div v-else>
                {{$t('dashboard.files.could_not_open')}}
            </div>
        </div>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import ModalWrapper from '@/components/general/ModalWrapper';

    @Component({
        components: {}
    })
    export default class ViewFileModal extends Vue {
        file = {};
        name = 'view-file-modal';
        loading = true;
        video = false;
        audio = false;
        image = false;
        pdf = false;
        url = '';

        beforeOpen(event) {
            this.file = event.params.file;
            Vue.axios.get(`account/${this.$route.params.user_id}/documents/${this.file.id}`, {responseType: 'blob'}
            ).then(resp => {
                this.url = window.URL.createObjectURL(resp.data);
                this.audio = resp.data.type.includes('audio');
                this.video = resp.data.type.includes('video');
                this.image = resp.data.type.includes('image');
                this.pdf = resp.data.type.includes('pdf');
                this.loading = false;

            }).catch(() => {
            }).then(() => this.loading = false);
        }

    }

    Vue.component('view-file-modal', ViewFileModal);
</script>
<style>
    img {
        max-width:100%; height:auto
    }
</style>


// WEBPACK FOOTER //
// src/components/modals/evaluations/ViewFileModal.vue